module.exports = __webpack_public_path__ + "img/animals_giraffe.7b70c1f0.png";